module.exports = __webpack_public_path__ + "img/vue.af8ea1eb.jpg";